import { Link, NavLink } from "react-router-dom";
import facebook from "../assets/img/social/facebook.png";
import insta from "../assets/img/social/insta.png";
import { header } from "../constants/header";
import { popular } from "../constants/popular";
import { FiClock, FiMail, FiMapPin, FiPhone } from "react-icons/fi";
import { payment } from "../constants/payment";

const CustomFooter = () => {
  return (
    <footer className="bg-gray-900 dark:bg-gray-900 text-white">
      <div className="mx-auto w-full max-w-screen-xl p-6 lg:p-8">
        {/* Top Section */}
        <div className="grid grid-cols-2 sm:grid-cols-12 gap-8">
          {/* Contact Us - 4 columns */}
          <div className="sm:col-span-4 flex flex-col">
            <h2 className="mb-4 text-lg font-semibold text-yellow-500 dark:text-white">
              Contact Us
            </h2>
            <ul className="font-medium">
              <li className="mb-3">
                <Link
                  to="https://maps.app.goo.gl/UkiUXka7a8tpCh9N9"
                  className="flex items-center space-x-2 hover:underline"
                >
                  <FiMapPin className="text-yellow-500 w-5 h-5 flex-shrink-0" />
                  <span>220B Keo Chea St. (184), Phnom Penh</span>
                </Link>
              </li>
              <li>
                <Link
                  to="tel:081333000"
                  className="flex items-center space-x-2 hover:underline mb-3"
                >
                  <FiPhone className="text-yellow-500 w-5 h-5 flex-shrink-0" />
                  <span>081 333 000</span>
                </Link>
              </li>
              <li>
                <Link to="#" className="flex items-center space-x-2 mb-3">
                  <FiClock className="text-yellow-500 w-5 h-5 flex-shrink-0" />
                  <span>Daily: 6:30AM-9:00PM</span>
                </Link>
              </li>
              <li>
                <Link to="#" className="flex items-center space-x-2">
                  <FiMail className="text-yellow-500 w-5 h-5 flex-shrink-0" />
                  <span>manticcup9@gmail.com</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Menu - 2 columns */}
          <div className="sm:col-span-2 flex flex-col">
            <h2 className="mb-4 text-lg font-semibold text-yellow-500 dark:text-white">
              Menu
            </h2>
            <ul className="space-y-2 font-medium">
              {popular.slice(0, 5).map((item, i) => (
                <li key={i}>
                  <NavLink to={item.path} className="hover:underline">
                    {item.title}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>

          {/* Follow Us - 2 columns */}
          <div className="sm:col-span-2 flex flex-col">
            <h2 className="mb-4 text-lg font-semibold text-yellow-500 dark:text-white">
              Follow Us
            </h2>
            <ul className="flex items-center space-x-4">
              <li>
                <Link target="_blank" to="https://www.facebook.com/ManticCup">
                  <img
                    src={facebook}
                    alt="Facebook"
                    className="h-8 w-8 object-contain"
                  />
                </Link>
              </li>
              <li>
                <Link to="/instagram">
                  <img
                    src={insta}
                    alt="Instagram"
                    className="h-10 w-10 object-contain"
                  />
                </Link>
              </li>
            </ul>
          </div>
          {/* Navigate - 4 columns */}
          <div className="sm:col-span-4 flex flex-col">
            <h2 className="mb-4 text-lg font-semibold text-yellow-500 dark:text-white">
              Navigate
            </h2>
            <ul className="grid gap-2 font-medium">
              {header.slice(0, 5).map((item, i) => (
                <li key={i}>
                  <Link to={item.path} className="hover:underline">
                    {item.key}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/* Divider */}
        <hr className="my-6 border-gray-200 dark:border-gray-700" />
        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4">
          <span className="text-sm text-white dark:text-gray-400 text-center sm:text-left">
            © 2025{" "}
            <Link
              to="https://maps.app.goo.gl/UkiUXka7a8tpCh9N9"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:underline"
            >
              Mantic Cup™
            </Link>
            . All Rights Reserved.
          </span>
          {/* Payment Methods */}
          <div className="flex flex-col items-center">
            <h3 className="text-white dark:text-gray-400  mb-2">
              Accept Payment Methods
            </h3>
            <div className="flex items-center space-x-4">
              {payment.map((item, index) => (
                <img
                  key={index}
                  src={item.img}
                  alt={item.title}
                  className="h-8 sm:h-10 object-contain rounded-sm transform transition-transform duration-300 ease-in-out hover:scale-110"
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default CustomFooter;
